// DS: IL9.4
import React from 'react';
export class Death extends React.PureComponent {
    render() {
        return /*#__PURE__*/ React.createElement("svg", {
            width: "88",
            height: "88",
            xmlns: "http://www.w3.org/2000/svg"
        }, /*#__PURE__*/ React.createElement("image", {
            href: "https://st.deviantart.net/eclipse/global/images/grim-reaper.png?1",
            width: "100%",
            height: "100%"
        }));
    }
}
